import styles from './ModalHeader.module.css'
import classNames from 'classnames'
import { Heading } from '../../Heading/Heading'

export interface ModalHeaderProps {
  variant: 'primary' | 'secondary' | 'tertiary'
  id: string
  heading: string
}

export const ModalHeader = ({ heading, variant = 'primary', id }: ModalHeaderProps) => {
  const headerClasses = classNames(styles.ModalHeader, {
    [styles[`ModalHeader--is-secondary`]]: variant === 'secondary',
    [styles[`ModalHeader--is-tertiary`]]: variant === 'tertiary',
  })

  return (
    <div className={headerClasses}>
      <Heading tagSize={4} id={id} fontClass="h4" color={variant === 'primary' ? 'white' : 'black'} noMarginBottom>
        {heading}
      </Heading>
    </div>
  )
}
